import React from 'react';
import { Pencil, ScrollText } from 'lucide-react';

const SUBTABS = [
  { id: 'edit', label: 'Edit', Icon: Pencil },
  { id: 'audit', label: 'Audit Log', Icon: ScrollText },
];

const NavbarMiddle = ({ activeTab, setActiveTab }) => (
  <div className="mb-4 flex justify-center">
    <div className="bg-white/90 backdrop-blur-sm px-3 py-1.5 rounded-full shadow-sm inline-flex gap-4">
      {SUBTABS.map(({ id, label, Icon }) => (
        <button
          key={id}
          type="button"
          onClick={() => setActiveTab(id)}
          className={`flex items-center gap-2 text-xs px-4 py-1.5 rounded-full transition-colors ${
            activeTab === id
              ? 'bg-module-accounts text-white'
              : 'hover:bg-gray-100 text-gray-700'
          }`}
        >
          <Icon className="h-4 w-4" strokeWidth={2} />
          {label}
        </button>
      ))}
    </div>
  </div>
);

export default NavbarMiddle;
